import * as React from 'react'
import { connect } from 'react-redux'
import { AnswersNotification } from './answersnotification'
import { OnlineNotification } from './onlinenotification'
import { RootState } from '../../types/rootstate'

interface StateProps {
  notification: RootState['notification']
}

interface DispatchProps {}

interface OwnProps {}

type NotificationProps = StateProps & DispatchProps & OwnProps

function mapStateToProps (state: RootState): StateProps {
  return {
    notification: state.notification
  }
}

function mapDispatchToProps (dispatch): DispatchProps {
  return {}
}

interface NotificationState {
  isOpened: boolean
}

class NotificationComponent extends React.Component<NotificationProps, NotificationState> {
  render () {
    if (this.props.notification.type === 'answers') {
      return (
        <AnswersNotification />
      )
    } else if (this.props.notification.type === 'online') {
      return (
        <OnlineNotification />
      )
    } else {
      return null
    }
  }
}

const Notification  = connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)(NotificationComponent)


export {
  Notification
}
